import { Notification } from '@app/components/various/Notification';
import { useTranslation } from 'react-i18next';

export const InvalidMatrixInfo = () => {
  const { t } = useTranslation(['configErrors']);

  return <Notification message={t('configErrors:invalid_matrix_configuration')} type="warning" isBordered className="mx-1 my-4" />;
};
